import { PaymentProvider, ProcessPaymentOptions } from '../../typings/Payment'
import { getGoogleSearchParam } from '../../lib/get-google-search-param'

const confirmPaymentIntent = async (
  paymentProvider: PaymentProvider,
  { elements, user }: ProcessPaymentOptions,
  lastPaymentAttempt: Date,
) => {
  const { stripe } = paymentProvider
  if (!stripe || !elements) {
    throw new Error('Stripe provider or elements was not found')
  }

  const returnUrlObject = {
    return_url: `${window.location.href}&paymentInProgress=true&lastPaymentAttempt=${lastPaymentAttempt.getTime()}&isReturningFromStripe=true`,
  }

  const trackingParam = getGoogleSearchParam()

  if (trackingParam) {
    const [trackingName, trackingValue] = trackingParam.split('=')
    const returnToAsURL = new URL(returnUrlObject.return_url)
    returnToAsURL.searchParams.append(trackingName, trackingValue)
    returnUrlObject.return_url = returnToAsURL.toString()
  }

  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      payment_method_data: {
        billing_details: {
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
        },
      },
      ...returnUrlObject,
    },
  })

  return { error }
}

export default confirmPaymentIntent
